<template>
  <div style="margin-top:20px;">
    <el-form ref="form" :rules="rules" :model="form" label-width="120px">
      <el-form-item label="账户余额" style="margin-right:15px">
        <span class="balance">{{ form.withdrawalAmount }}元</span>
      </el-form-item>
      <el-form-item label="提现账户" style="margin-right:15px">
        <span class="balance">{{ form.withdrawalAccount }}</span>
      </el-form-item>
      <el-form-item label="提现金额(元)" prop="amount" style="margin-right:15px">
        <el-input
          v-model="form.amount"
          :span="10"
          placeholder="请输入提现金额"
          @input="(value)=>formFormatter.isFloor2(value,oldValue,form,'amount')"
        /> 
      </el-form-item>
      <el-form-item label="验证码" prop="verifyCode" style="margin-right:15px">
        <el-col :span="10">
          <el-input
            v-model="form.verifyCode"
            placeholder="请输入验证码"
            @input="(value)=>{form.verifyCode = value.replace(/[^0-9]*/g,'')}"
          />
        </el-col>
        <el-col :span="2" style="margin-left:15px">
          <el-button :type="isType" :disabled="!isCode" @click="getPhoneCode">{{ codeName }}</el-button>
        </el-col> 
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer"> 
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button type="primary" @click="funcSubmit">
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import { WithdrawalData,sendWsWithdrawCode,withdrawal } from "@/api/collectioncoding";
import { isFixed2,isNumber } from '@/utils/validate4Form'
export default {
  name: "CodingDeposit",
  props: {
    cascadeData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      emptyForm: {},
      isType:'primary',
      vardel: false,
      codeName: '发送验证码',
			isCode: true,
      partyCode:'',
      form: {
        code:"",
        withdrawalAccount:'', //提现账户
        withdrawalAmount:'', //提现余额
        verifyCode:'',
        amount:'',
      },
     rules: {
       amount: [
          { required: true, message: '请输入提现金额', trigger: 'blur' },
          { validator: isFixed2, trigger: "blur" },
        ],
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: isNumber, trigger: "blur" },
        ],
     },
     timer: null,
     date: 60,
    };
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    getPhoneCode() { 
      const rLoading = this.openLoading();
      this.timer = null
      this.date = 60
      let that = this
      const branchCode = that.branchCode
      sendWsWithdrawCode({branchCode}).then(response => {
        rLoading.close();
        if (that.isCode == true) {
          this.$message({
            message: '验证码发送成功',
            type: "success",
          });
          clearInterval(that.timer)
          that.isCode = false
          that.timer = setInterval(() => {
            if (that.date >= 1) {
              that.date--
              that.codeName = that.date + '秒重试'
            } else {
              that.isCode = true
              that.codeName = '重新发送验证码'
              clearInterval(that.timer)
              that.timer = null
            }
          }, 1000)
        }
      });
    },
    receive(data) {
      this.form = data
      this.vardel = false;
   },
    // 获取页面信息
    findList(data) {
      if(this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.oldValue['amount'] = ''
      this.$refs.form.resetFields() 
      this.form = {}
      this.partyCode = data.partyCode
      this.branchCode = data.branchCode
      const code = data.code     
        return new Promise(resolve => {
        WithdrawalData({code}).then(response => {
         this.form = response.data
          this.$emit("fatherEditMethod");
          resolve();
        });
     });
    },
    // 提交
    funcSubmit() {
      const data = {
          amount:this.form.amount,
          verifyCode:this.form.verifyCode,
          partyCode:this.partyCode
      };
      if(parseFloat(this.form.amount) > parseFloat(this.form.withdrawalAmount)){
        this.$message({
          message: "提现金额不能大于账户余额",
          type: "error",
        });
        return;
      }
      const rLoading = this.openLoading(); 
      return new Promise(resolve => {
        withdrawal(data).then(response => {
          rLoading.close();
          this.$message({
            message: response.msg,
            type: "success",
          });
          this.$emit("fatherDepositMethod");
          resolve();
        });
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "Deposit");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
.balance{
  font-weight: bold;
  font-size: 16px;
}
</style>
